import { useEffect, useRef } from "react";

import { FormProvider } from "react-hook-form";

import {
  PRACTITIONER_PROFILE_QUERY,
  UPGRADE_STUDENT_PRACTITIONER_LEVEL_MUTATION
} from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";
import ButtonV2 from "@/v2/Buttons";

import StudentPractitionerUpgrade from "../sections/StudentPractitionerUpgrade";

export default function StudentPractitionerProfileForm({ practitionerProfile }) {
  const api = useDjangoGraphqlForm({
    defaultValues: {
      level: "",
      documents: []
    },
    mutation: UPGRADE_STUDENT_PRACTITIONER_LEVEL_MUTATION,
    mutationName: "upgradePractitionerLevelMutation",
    mutationOptions: {
      refetchQueries: [
        {
          query: PRACTITIONER_PROFILE_QUERY
        }
      ]
    },
    transformer: data => ({
      ...data,
      documents: JSON.stringify(
        data.documents.reduce((acc, doc) => {
          if (doc.type in acc) {
            return {
              ...acc,
              [doc.type]: [
                ...acc[doc.type],
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          } else {
            return {
              ...acc,
              [doc.type]: [
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          }
        }, {})
      )
    }),
    handleSuccess: ({ data, api: { reset } }) => {
      reset({
        level: "",
        documents: []
      });
    },
    handleFailure: () => {}
  });

  const {
    methods: { reset }
  } = api;

  useEffect(() => {
    if (practitionerProfile?.currentPractitionerLevel?.level) {
      reset({
        level: practitionerProfile?.currentPractitionerLevel?.level,
        documents: []
      });
    }
  }, [reset, practitionerProfile?.currentPractitionerLevel?.level]);

  return (
    <>
      <FormProvider {...api.methods}>
        <form
          onSubmit={e => {
            api.methods.clearErrors();
            api.methods.handleSubmit(api.onSubmit)(e);
          }}
        >
          {practitionerProfile?.currentPractitionerLevel?.level != "Full access" ? (
            <StudentPractitionerUpgrade
              currentLevel={practitionerProfile?.currentPractitionerLevel?.level}
              approved={practitionerProfile?.currentPractitionerLevel?.approved}
              patientOrderPermission={practitionerProfile?.currentPractitionerLevel?.patientOrderPermission}
            >
              {/* Should we not have a state for indicating submission in process */}
              <ButtonV2
                color="dark"
                withChevron
                size={["xs", "sm"]}
                sx={{
                  mx: "auto",
                  mt: 40 // plus 40px from stack component containing this button
                }}
                disabled={api.loading || !api.methods.formState.isDirty}
                type="submit"
              >
                submit
              </ButtonV2>
            </StudentPractitionerUpgrade>
          ) : null}
        </form>
      </FormProvider>
    </>
  );
}
